import { userDirectoryListFunctionName } from '../../../../backend/features/user-directory/shared';
import { useFunctionClient } from '@juvare/platform-sdk-react/ui/hooks';
import { laggy } from '@juvare/platform-sdk-react/ui/utils';
import useSWR from 'swr';
export function useUserDirectoryList(request, useResolveUserDirectoryFilter) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const functionClient = useFunctionClient();
    const resolvedFilter = useResolveUserDirectoryFilter({ filterData: request.filterData });
    let filter = (_a = resolvedFilter.data) !== null && _a !== void 0 ? _a : [];
    filter = applyFilterDataAsMetadata(filter, request.filterData);
    const fetcher = (request) => {
        const backendRequest = Object.assign(Object.assign({}, request), { filterData: filter });
        if (Object.entries(request.filterData).length === 0) {
            return Promise.resolve({ result: { rows: [], total: 0, customBackendResponseData: { error: 'no-filter' } } });
        }
        return functionClient.executeFunction({ functionName: userDirectoryListFunctionName, params: backendRequest });
    };
    const response = useSWR(request, fetcher, {
        use: [laggy],
        revalidateOnFocus: false,
    });
    return {
        data: {
            rows: (_d = (_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.rows) !== null && _d !== void 0 ? _d : [],
            filteredRowCount: (_g = (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.result) === null || _f === void 0 ? void 0 : _f.total) !== null && _g !== void 0 ? _g : 0,
        },
        customBackendResponseData: (_j = (_h = response.data) === null || _h === void 0 ? void 0 : _h.result) === null || _j === void 0 ? void 0 : _j.customBackendResponseData,
        reload: response.mutate,
        isLoading: response.isLoading,
        error: response.error,
    };
}
/**
 * This function ensures that filter data is applied as metadata within first storageFilter element.
 * This could happen if product has overrideUseAccountFilter implemented, but no ContactManagement filters were set within filterData.
 * @param storageFilter
 * @param filterData
 */
function applyFilterDataAsMetadata(storageFilter, filterData) {
    if (storageFilter.length && !storageFilter[0].metadata) {
        storageFilter[0].metadata = { ui: filterData };
    }
    return storageFilter;
}
